import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { isVoucherError, voucherExceededError, voucherInvalidError } from '@spartacus/cart/base/core';
import {
  ErrorModel,
  GlobalMessageType,
  HttpErrorHandler,
  HttpResponseStatus,
  Priority
} from '@spartacus/core';

@Injectable({
  providedIn: 'root',
})
export class CustomBadVoucherRequestHandler extends HttpErrorHandler {
  responseStatus = HttpResponseStatus.BAD_REQUEST;

  getPriority(): Priority {
    return Priority.HIGH;
  }

  hasMatch(errorResponse: HttpErrorResponse): boolean {
    return (
      super.hasMatch(errorResponse) &&
      this.getErrors(errorResponse).some(isVoucherError)
    );
  }

  handleError(request: HttpRequest<any>, response: HttpErrorResponse): void {
    this.handleVoucherExceededError(request, response);
    this.handleVoucherInvalidError(request, response);
    this.handleVoucherOperationError(request, response);
  }

  protected handleVoucherExceededError(
    _request: HttpRequest<any>,
    response: HttpErrorResponse
  ): void {
    this.getErrors(response)
      .filter((e) => voucherExceededError(e))
      .forEach(() => {
        this.globalMessageService.add(
          { key: 'httpHandlers.voucherExceeded' },
          GlobalMessageType.MSG_TYPE_ERROR
        );
      });
  }

  protected handleVoucherInvalidError(
    _request: HttpRequest<any>,
    response: HttpErrorResponse
  ): void {
    this.getErrors(response)
      .filter((e) => voucherInvalidError(e))
      .forEach(() => {
        this.globalMessageService.add(
          { key: 'httpHandlers.invalidCodeProvided' },
          GlobalMessageType.MSG_TYPE_ERROR
        );
      });
  }


  private handleVoucherOperationError(
    _request: HttpRequest<any>,
    response: HttpErrorResponse,
  ): void {
    const messages = {
      'coupon.already.exists.cart': 'httpHandlers.couponAlreadyExistsCart',
      'coupon.not.active.expired': 'httpHandlers.couponExpired',
      'coupon.already.redeemed': 'httpHandlers.couponAlreadyRedeemedCart',
      'coupon.invalid.code.provided': 'httpHandlers.invalidCodeProvided',
      'The application has encountered an error': 'httpHandlers.invalidCodeProvided',
    };
    this.getErrors(response)
      .filter(
        (e) =>
          !!messages[e.message] && e.type === 'VoucherOperationError',
      )
      .forEach((e) => {
        if (!!messages[e.message]) {
          this.globalMessageService.add(
            { key: messages[e.message] },
            GlobalMessageType.MSG_TYPE_ERROR,
          );
        } else {
          this.globalMessageService.add(
            { key: 'httpHandlers.invalidCodeProvided' },
            GlobalMessageType.MSG_TYPE_ERROR,
          );
        }
      });
  }

  protected getErrors(response: HttpErrorResponse): ErrorModel[] {
    return (response.error?.errors || []).filter(
      (error: ErrorModel) => error.type !== 'JaloObjectNoLongerValidError'
    );
  }
}
